/**
 * 接口域名的管理
 */
const baseurl = {
    url: 'https://api.gundongyongheng.com/ver/index.php',
}
const options ={
    token:localStorage.getItem('token')
}

export default {baseurl,options};



// WEBPACK FOOTER //
// ./src/api/request/base.js